import type { SVGProps } from "react";

export const GoogleForms = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 192 192"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Forms</title>
    <rect fill="#969dff" height="50" rx="25" width="102" x="70" y="121" />
    <rect fill="#b8c0ff" height="50" rx="25" width="50" x="20" y="121" />
    <rect fill="#5746e3" height="50" rx="25" width="50" x="20" y="71" />
    <rect fill="#5746e3" height="50" rx="25" width="102" x="70" y="71" />
    <mask
      height="50"
      id="gforms-mask"
      maskUnits="userSpaceOnUse"
      style={{ maskType: "alpha" }}
      width="102"
      x="70"
      y="21"
    >
      <rect fill="#5f54f4" height="50" rx="25" width="102" x="70" y="21" />
    </mask>
    <g mask="url(#gforms-mask)">
      <rect fill="#7372fe" height="50" rx="25" width="102" x="70" y="21" />
      <g filter="url(#gforms-blur)">
        <circle cx="56" cy="46" fill="#64afff" r="36" />
      </g>
    </g>
    <rect fill="#7372fe" height="50" rx="25" width="50" x="20" y="21" />
    <path d="M95 46h52" stroke="#fff" strokeLinecap="round" strokeWidth="12" />
    <circle cx="45" cy="46" fill="#fff" r="12" />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="111.47"
        id="gforms-blur"
        width="111.47"
        x=".27"
        y="-9.74"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation="9.87" />
      </filter>
    </defs>
  </svg>
);

export default GoogleForms;
